import React, { useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import NavBar from './components/NavBar';
import Home from './views/Home';
import About from './views/About';
import Services from './views/Services';
import Contact from './views/Contact';
import Gallery from './views/Gallery';
import Request from './components/Request';
import { useLoading } from './context/LoadingContext';
import TermsAndConditions from './components/TermsAndConditions';
import Privacy from './components/Privacy';
import ChatNow from './components/ChatNow';
import BackToTopButtom from './components/BackToTopButtom';
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import './App.css';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

function App() {
  const { isLoading, setIsLoading } = useLoading();

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      await new Promise((resolve) => setTimeout(resolve, 1000));
      setIsLoading(false);
    };
    fetchData();
  }, [setIsLoading]);

  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <div className="overflow-hidden relative">
          <NavBar />
          {isLoading ? (
            <>
              <div className="flex items-center justify-center h-screen">
                <div className="animate-spin h-12 w-12 border-4 border-blue-500 border-dashed rounded-full" />
              </div>
            </>
          ) : (
            <Routes>
              <Route path='/' element={<Home />} />
              <Route path='/about' element={<About />} />
              <Route path='/services' element={<Services />} />
              <Route path='/contact' element={<Contact />} />
              <Route path='/gallery' element={<Gallery />} />
              <Route path='/request' element={<Request />} />
              <Route path='/terms-and-conditions' element={<TermsAndConditions />} />
              <Route path='/privacy' element={<Privacy />} />
            </Routes>
          )}
          <ChatNow />
          <div className='p-2 ml-8'>
            <BackToTopButtom />
          </div>
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
